export const CUSTOMER_DEFAULT_PAGE = ""
export const CUSTOMER_PAGES_BASE = {
  "": "Overview",
}
export const CUSTOMER_PAGES_ADVANCED = {
  usage: "Usage",
  reporting: "Download",
  forecast: "Forecasting",
}
export const CUSTOMER_PAGES_REPORTING = {
  reporting: "Download",
}
export const CUSTOMER_SITE_DEFAULT_PAGE = ""
export const CUSTOMER_SITE_PAGES_BASE = {
  "": "Overview",
}

export const SITE_DEFAULT_PAGE = "assets"
export const SITE_PAGES_BASE = {}
export const SITE_PAGES_WITH_ASSETS = {}

export const ASSET_DEFAULT_PAGE = "monitoring"
export const ASSET_PAGES = {
  history: "Log",
  monitoring: "Monitoring",
}

import { SYSTEM_DEFAULT_PAGE, SYSTEM_PAGES } from "@hydrologiq/systems/components/selection/pages"

export const pages = (
  location: string,
  customer: boolean,
  site: boolean,
  asset: boolean,
  system: boolean,
  customerAdvancedEnabled: boolean = true,
  customerReportingEnabled: boolean = true
): {
  section: string
  name: string
  pages: Record<string, string>
  defaultPage: string
  parent?: { section: string; name: string; id?: string }
} => {
  let page = location.split("/").pop()
  let sectionPages: Record<string, string> = {}
  let defaultPage = ""

  if (customer && !site && !asset) {
    sectionPages = customerAdvancedEnabled
      ? { ...CUSTOMER_PAGES_BASE, ...CUSTOMER_PAGES_ADVANCED }
      : CUSTOMER_PAGES_BASE
      if (customerReportingEnabled) {
        sectionPages = { ...sectionPages, ...CUSTOMER_PAGES_REPORTING }
      }
    defaultPage = CUSTOMER_DEFAULT_PAGE
  }
  if (site && !asset) {
    sectionPages = customerAdvancedEnabled ? { ...SITE_PAGES_BASE, ...SITE_PAGES_WITH_ASSETS } : SITE_PAGES_BASE
    defaultPage = SITE_DEFAULT_PAGE
  }
  if (asset) {
    sectionPages = ASSET_PAGES
    defaultPage = ASSET_DEFAULT_PAGE
  }
  if (site && system) {
    sectionPages = SYSTEM_PAGES
    defaultPage = SYSTEM_DEFAULT_PAGE
  }

  let section = page ?? defaultPage
  let name = sectionPages[section]
  if (!name) {
    section = defaultPage
    name = sectionPages[defaultPage]
  }

  sectionPages =
    Object.keys(sectionPages).length === 1 && Object.keys(sectionPages).includes(defaultPage) ? {} : sectionPages
  return { section, name, pages: sectionPages, defaultPage }
}
